import { DotsBackground } from '@/components/DotsBackground'
import { Kicker } from '@/components/Kicker'
import { RevealSection } from '@/components/RevealSection'
import RichText from '@/components/RichText'
import { cn } from '@/utilities/ui'

import { LinksBlock } from './components/LinksBlock'

import type { CallToActionBlock as CTABlockProps } from '@/payload-types'

export type CallToActionBlockProps = CTABlockProps & {
  stateSelectProps?: {
    handleStateChange?: (state: string | undefined) => void
    stateSelectMobileRef?: React.RefObject<HTMLSelectElement>
    stateSelectDesktopRef?: React.RefObject<HTMLButtonElement>
    selectedState?: string | undefined
  }
  showStateSelect?: boolean
  className?: string
}

export const CallToActionBlock: React.FC<CallToActionBlockProps> = ({
  stateSelectProps,
  showStateSelect = false,
  className = '',
  links,
  kicker,
  richText,
  header,
  reverse,
}) => {
  return (
    <div className={cn('relative wrapper', className)}>
      <div className="flex min-h-92 flex-col gap-8 overflow-hidden rounded-2xl bg-card md:grid md:grid-cols-2">
        {/* Content */}
        <RevealSection
          stagger
          className={cn(
            'relative z-4 flex max-w-3xl flex-col justify-center gap-6 px-5 py-12 max-md:order-1 md:px-12',
            reverse ? 'order-2' : 'order-1',
          )}
        >
          <div>
            {kicker && (
              <Kicker tone="default" className="w-fit">
                {kicker}
              </Kicker>
            )}
            <h2 className="mt-1 mb-0 max-w-[40ch] font-display text-4xl font-normal lg:text-5xl">
              {header}
            </h2>
          </div>
          <div>
            {richText && (
              <RichText
                className="mb-0 font-body text-base font-normal text-secondary-foreground"
                data={richText}
                enableGutter={false}
              />
            )}
          </div>
          <LinksBlock
            links={links}
            showStateSelect={showStateSelect}
            stateSelectProps={stateSelectProps}
          />
        </RevealSection>

        {/* Dots Background */}
        <RevealSection
          className={cn(
            'relative z-3 flex h-72 w-full max-md:order-2 max-md:-mt-28 md:h-full',
            reverse ? 'order-1' : 'order-2',
          )}
        >
          <DotsBackground svgClassName="max-md:scale-150 max-md:-translate-x-5" />
        </RevealSection>
      </div>
    </div>
  )
}
